import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { ExperienceSelector } from '../components/ExperienceSelector';
import { AboutSection } from '../components/AboutSection';
import { VenueSection } from '../components/VenueSection';
import { EventsSection } from '../components/EventsSection';
import { FeaturedFlyers } from '../components/FeaturedFlyers';
import { SectionDivider } from '../components/SectionDivider';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen bg-[#0B1014] text-white selection:bg-[#DDA247] selection:text-[#0B1014]" data-id="element-1379">
      <Header data-id="element-1380" />
      <main data-id="element-1381">
        <Hero data-id="element-1382" />
        <ExperienceSelector data-id="element-1383" />
        <SectionDivider data-id="element-1384" />
        <FeaturedFlyers data-id="element-1385" />
        <SectionDivider data-id="element-1386" />
        <AboutSection data-id="element-1387" />
        <SectionDivider data-id="element-1388" />
        <VenueSection data-id="element-1389" />
        <SectionDivider data-id="element-1390" />
        <EventsSection data-id="element-1391" />
      </main>
      <Footer data-id="element-1392" />
    </div>;
}